import { Link } from 'react-router-dom';
import { MS_PAGES, msPath, useMsCopy, useMsLocale } from '@/membersheep/i18n';

/**
 * Catch-all under /membersheep, prerendered to dist/membersheep/404.html and
 * dist/membersheep/zh-tw/404.html. noindex, no canonical.
 */
const MsNotFoundPage = () => {
  const copy = useMsCopy();
  const locale = useMsLocale();

  return (
    <main className="mx-auto flex max-w-[1080px] flex-col items-start gap-5 px-4 pt-24 md:px-6 md:pt-36">
      <title>{copy.seo.notFound}</title>
      <meta name="robots" content="noindex" />
      <p className="font-display text-[clamp(72px,14vw,160px)] leading-none font-extrabold tracking-[-0.05em] text-ms-blue/40">404</p>
      <h1 className="font-display text-4xl font-extrabold tracking-[-0.03em]">{copy.notFound.heading}</h1>
      <p className="text-sys-secondary">{copy.notFound.body}</p>
      <Link to={msPath(locale, MS_PAGES.home)} className="rounded-xl bg-ms-accent px-5 py-3 text-[15px] font-semibold text-white dark:bg-ms-blue">
        {copy.notFound.cta}
      </Link>
    </main>
  );
};

export default MsNotFoundPage;
